import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { useTranslations } from '@lang';
import RegisterForm from '@features/account/pages/Register/components/RegisterForm';
import {
  Background,
  Content,
  Heading,
  SectionContainer,
} from '@common/components/AuthLayout/Layout';

import { Link } from 'shared-routing';
import { Routes } from '@common/constants';

import { createGuest } from '@store/guest/actions';
import { entitySelectors } from '@store/entity/selectors';

export const RegisterContainer = ({
  homepage = null,
  createGuest,
  propertyId,
  spaIntegrated = false,
}) => {
  const { t } = useTranslations();

  return (
    <SectionContainer>
      <Content>
        <Heading>{t('register.header')}</Heading>
        <RegisterForm
          onSubmit={(data) => createGuest(propertyId, data)}
          spaIntegrated={spaIntegrated}
        />
        {t('register.alreadyHaveAccount')} <Link route={Routes.SIGNIN}>{t('common.signIn')}</Link>
      </Content>
      <Background
        src={homepage && homepage.heroBackgroundImage && homepage.heroBackgroundImage.url}
      />
    </SectionContainer>
  );
};

RegisterContainer.propTypes = {
  homepage: PropTypes.shape({
    heroBackgroundImage: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  createGuest: PropTypes.func.isRequired,
  propertyId: PropTypes.number.isRequired,
  spaIntegrated: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { homepage } = entitySelectors.getProperty(state, ownProps.id);

  const homepageId = homepage ? homepage.id : null;
  return {
    homepage: entitySelectors.getHomepage(state, homepageId),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createGuest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContainer);
